var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"id":"start"},on:{"click":_vm.start}},[_vm._v("开始录制")]),_c('button',{attrs:{"id":"stop"},on:{"click":_vm.stop}},[_vm._v("结束录制")]),_c('button',{attrs:{"id":"play"},on:{"click":_vm.play}},[_vm._v("播放")]),_c('audio',{attrs:{"id":"audio","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }